export default __webpack_public_path__ + "static/media/UniSansThin.946fca7c.otf";